// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Admin__ArgumentCategoryController from "./admin/argument_category_controller"
application.register("admin--argument-category", Admin__ArgumentCategoryController)

import Admin__CoursesPickerController from "./admin/courses_picker_controller"
application.register("admin--courses-picker", Admin__CoursesPickerController)

import Admin__CoursesSearchController from "./admin/courses_search_controller"
application.register("admin--courses-search", Admin__CoursesSearchController)

import Admin__DraggableSignatureController from "./admin/draggable_signature_controller"
application.register("admin--draggable-signature", Admin__DraggableSignatureController)

import Admin__ItemManagerController from "./admin/item_manager_controller"
application.register("admin--item-manager", Admin__ItemManagerController)

import AttachmentController from "./attachment_controller"
application.register("attachment", AttachmentController)

import AutoLogoutController from "./auto_logout_controller"
application.register("auto-logout", AutoLogoutController)

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import ChoicesController from "./choices_controller"
application.register("choices", ChoicesController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import DeliveriesController from "./deliveries_controller"
application.register("deliveries", DeliveriesController)

import DomainSelectorController from "./domain_selector_controller"
application.register("domain-selector", DomainSelectorController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import InputFieldController from "./input_field_controller"
application.register("input-field", InputFieldController)

import InstructorAcknowledgementController from "./instructor_acknowledgement_controller"
application.register("instructor-acknowledgement", InstructorAcknowledgementController)

import LazyLoadingController from "./lazy_loading_controller"
application.register("lazy-loading", LazyLoadingController)

import ListController from "./list_controller"
application.register("list", ListController)

import LocatorController from "./locator_controller"
application.register("locator", LocatorController)

import MultiUploadController from "./multi_upload_controller"
application.register("multi-upload", MultiUploadController)

import ObserveAttendanceController from "./observe_attendance_controller"
application.register("observe-attendance", ObserveAttendanceController)

import ObserveSignatureController from "./observe_signature_controller"
application.register("observe-signature", ObserveSignatureController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import RemoteModalController from "./remote_modal_controller"
application.register("remote-modal", RemoteModalController)

import SignaturePadController from "./signature_pad_controller"
application.register("signature-pad", SignaturePadController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import ValuePickerController from "./value_picker_controller"
application.register("value-picker", ValuePickerController)
